<style lang="scss">
    tbody i
    {
        margin-left: 10px;
    }
</style>

<template>
    <div class="row justify-content-start">
        <div class="col-auto">
            <div class="input-group input-group-sm mb-3">
                <span class="input-group-text" id="filter">{{ $trans('company.name') }}</span>
                <input v-model="filter" type="text" aria-describedby="filter">
            </div>
        </div>
        <div class="col-auto">
            <div class="form-check">
                <input @change="loadPage" v-model="inactiveOnly" class="form-check-input" type="checkbox" value="false" id="inactiveOnly">
                <label class="form-check-label" for="inactiveOnly">
                    {{ $trans('company.inactive_only') }}
                </label>
            </div>
        </div>
    </div>
	<table class="table table-dark table-striped">
		<thead>
			<tr>
				<th scope="col">{{ $trans('company.id') }}</th>
				<th scope="col">{{ $trans('company.name') }}</th>
				<th scope="col" class="text-center">{{ $trans('company.active') }}</th>
				<th scope="col" class="text-center">{{ $trans('acp.options') }}</th>
			</tr>
		</thead>
        <tbody>
            <tr v-for="(company, index) in companies.data" v-bind:key="company.id">
                <th scope="row">{{ company.id }}</th>
                <td>{{ company.name }}</td>
                <td class="text-center">
                    <i v-if="company.active" class="fas fa-check"></i>
                    <i v-else class="fas fa-times"></i>
                </td>
                <td class="text-center"> 
                    <inertia-link v-if="policies.COMPANY_CREATE" :href="route('company/create')" :data="{ id: company.id }" class="text-light"><i class="far fa-edit fa-lg"></i></inertia-link>
                    <a v-if="policies.COMPANY_DELETE"  @click="_delete(company.id)" class="text-light"><i class="far fa-trash-alt fa-lg"></i></a>
                </td>
            </tr>
		</tbody>
	</table>

    <pagination :options="paginationOptions" ref="pagination" v-model="companies.current_page" :records="companies.total" :per-page="companies.per_page" @paginate="loadPage()"/>

    <div>
        <Link as="button" :href="route('company/create')" type="button" class="btn btn-primary" :preserveState="false">{{ $trans('acp.company_create') }}</Link>
    </div>

    <div class="modal fade" id="modal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalLabel">{{ $trans('acp.title_modal_delete_company') }}</h5>
                    <button type="button" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times fa-2x"></i></button>
                </div>
                <div class="modal-body">
                    {{ $trans('acp.body_modal_delete_company') }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans('acp.close') }}</button>
                    <button @click="deleteAction()" type="button" class="btn btn-primary">{{ $trans('acp.delete') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import ACPLayout from "@/Layouts/ACP";
	import { Link } from '@inertiajs/inertia-vue3'
    import { Modal } from 'bootstrap'
    import { Inertia } from '@inertiajs/inertia'
    import { markRaw } from 'vue'
    import Pagination from 'v-pagination-3'
    import CustomPagination from '@/Components/Pagination.vue'

	export default {
		layout: ACPLayout,
        data() {
            return {
                companyId: 0,
                modal: false,
                page: 1,
                filter: '',
                filterTimeout: false,
                paginationOptions: { template: markRaw(CustomPagination) },
                inactiveOnly: false
            }
        },
        watch: {
            filter(newVar, oldVar)
            {
                let vueThis = this;
                clearTimeout(this.filterTimeout);
                this.filterTimeout = setTimeout(function () { vueThis.loadPage() }, 1000);
            }
        },
        props: {
            companies: Object,
            policies: Object,
        },
        components: {
            Link,
            Pagination, 
            CustomPagination 
        },
        methods: {
            loadPage(page = false) {

                this.$inertia.reload({
                data: { 'page' : (page === false ? this.companies.current_page : page), 'filter' : this.filter, 'inactiveOnly': this.inactiveOnly },
                only: ['companies']});
            },
            _delete(cId) {
                this.companyId = cId;
                this.modal = new Modal(document.getElementById('modal'));
                this.modal.show();
            },
            deleteAction() {
                let vueThis = this;
                let componentModal = this.modal;
                axios.post('/company/delete', { 'id' : this.companyId })
                    .then(function(result) 
                    { 
                        Inertia.reload({
                            data: { 'page' : vueThis.companies.current_page, 'filter' : vueThis.filter },
                            only: ['companies']}
                        );
                        componentModal.hide();
                    })
                    .catch(error => { this.searchingProcess = false; }); 
            }
        },
		setup(props) {},
	};
</script>
